/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlanDto } from '../../models/plan-dto';

export interface BillingPlansPlanIdGet$Plain$Params {
  planId: string;
}

export function billingPlansPlanIdGet$Plain(http: HttpClient, rootUrl: string, params: BillingPlansPlanIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<PlanDto>> {
  const rb = new RequestBuilder(rootUrl, billingPlansPlanIdGet$Plain.PATH, 'get');
  if (params) {
    rb.path('planId', params.planId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlanDto>;
    })
  );
}

billingPlansPlanIdGet$Plain.PATH = '/billing/plans/{planId}';
